import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// antd
import { Form, Modal, Row, Upload, message } from 'antd'
import { InboxOutlined } from '@ant-design/icons'

// slices
import { loginState } from '../../login/login.slice'
import { supportTaskById, supportState } from './support.slice'

// components
import Button from '../../../components/button/button'
import { IconAttechment } from '../../../assets/icons/attechment'

const SupportAttachmentSectionButton = ({ getFileList, isText = false }) => {
    const { Dragger } = Upload

    const dispatch = useDispatch()

    const { userProfile } = useSelector(loginState)
    const { selectedTask } = useSelector(supportState)

    const [uploadFileModal, setUploadFileModal] = useState(false)

    const [uploadLoadingButton, setUploadLoadingButton] = useState(false)

    const [fileList, setFileList] = useState([])

    const [fileURL, setFileURL] = useState([])

    const props = {
        name: 'file',
        multiple: true,
        onChange(info) {
            let fileUpload = []
            if (info?.fileList?.length > 0) {
                fileUpload.push(...info?.fileList)
            }
            setFileURL(fileUpload)
        },
        beforeUpload(file) {
            setFileList([...fileList, file])

            return false
        },
        onDrop(e) {},
    }

    // ON FILE UPLOAD
    const onFileUpload = async () => {
        // For support, we just pass files to parent component
        // The actual upload will be handled when comment is submitted
        getFileList(fileURL)
        setUploadFileModal(false)
        setFileList([])
        setFileURL([])
    }

    const onFinishFailed = () => {}

    return (
        <>
            <Row
                style={{
                    float: 'right',
                }}
                align={'middle'}
            >
                {isText ? (
                    <Button
                        props={{
                            icon: <IconAttechment />,
                            buttonType: 'link',
                            type: 'files',
                            onClick: () => setUploadFileModal(true),
                            style: {
                                letterSpacing: '0.7px',
                                color: '#4F46E5',
                            },
                        }}
                    />
                ) : (
                    <Button
                        props={{
                            text: 'Attachment',
                            icon: <IconAttechment />,
                            buttonType: 'link',
                            type: 'files',
                            onClick: () => setUploadFileModal(true),
                            style: {
                                letterSpacing: '0.7px',
                                color: '#4F46E5',
                                justifyContent: 'center',
                            },
                        }}
                    />
                )}
            </Row>
            <Modal
                footer={null}
                closable={false}
                open={uploadFileModal}
                destroyOnClose={true}
                onCancel={() => {
                    setFileList([])
                    setUploadFileModal(false)
                }}
            >
                <Form
                    layout="vertical"
                    name="statusUpdate"
                    onFinish={onFileUpload}
                    onFinishFailed={onFinishFailed}
                    initialValues={{
                        file: [],
                    }}
                    requiredMark={false}
                >
                    <Form.Item name="dragger" noStyle className="fileDragger">
                        <Dragger
                            {...props}
                            showUploadList={{
                                showPreviewIcon: false,
                            }}
                            accept="*"
                        >
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">
                                Click or drag file to this area to upload
                            </p>
                            <p className="ant-upload-hint">
                                Support for a single or bulk upload. Strictly
                                prohibited from uploading company data or other
                                banned files.
                            </p>
                        </Dragger>
                    </Form.Item>
                    {fileList?.length === 0 ? (
                        <></>
                    ) : (
                        <Row>
                            <Button
                                props={{
                                    text: 'Upload',
                                    loadingButton: uploadLoadingButton,
                                    onClick: () => {
                                        getFileList(fileURL)
                                        setUploadFileModal(false)
                                        setFileList([])
                                    },
                                    style: {
                                        width: '100%',
                                    },
                                }}
                            />
                        </Row>
                    )}
                </Form>
            </Modal>
        </>
    )
}

export default SupportAttachmentSectionButton
